<template v-if="card">
  <div>
    <select-entity-combobox
      v-if="card.cardType.queryType"
      :events="[event]"
      :cardIds="[card.id]"
      :style="{
        '--borderColor': card.isInContext ? cardTypeColor : '#868686',
        '--borderTopWidth': '1px'
      }"
    />
    <text-editor
      v-if="card.cardType.triggerType"
      class="pa-1"
      :id="card.id"
      :text="card.description"
      :disabled="store.state.isWorkflowDisabled"
      @text-update="(e) => updateDescription(e, card.id)"
      @text-delta="emit('text-delta')"
      @move-focus="moveFocus"
      @keydown.native.stop=""
      :borderColor="cardTypeColor"
    />
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import TextEditor from '@/components/TextEditor'
import SelectEntityCombobox from '@/components/SelectEntityCombobox'
import workflowApi from '@/api/workflowApi'

const { event, card } = defineProps({
  event: Object,
  card: Object
})
const emit = defineEmits(['text-delta'])

const store = useStore()
const route = useRoute()

const cardTypeColor = computed(() => {
  const color = card?.cardType?.color
  return (color && `rgb(${color.red},${color.green},${color.blue})`) || 'transparent'
})

const moveFocus = (_, target) => {
  target.firstChild.blur()
}

const updateDescription = (html, itemId) => {
  workflowApi.updateRequirementsJsonMutation(route.params.id, [{ requirementId: itemId, description: html }])
}
</script>

<style scoped>
.requirement-card {
  min-width: 200px;
  max-width: 300px;
  margin: 0 auto;
  overflow: hidden;
  padding: 12px;
  border-radius: 8px;
  background: #FFF;
  border-width: 2px 1px 1px 1px;
  border-style: solid;
  border-color: black;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
}

.textEditor.ql-editor.ql-container {
  min-height: 31px;
}
</style>
